  window.addEventListener("klaviyoForms", function(e) { 
    console.log(e);
    if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
      gtag('event', 'form_open', {'form': 'Klaviyo form', 'form_id': e.detail.formId});
    }
    if (e.detail.type == 'submit') {
      gtag('event', 'form_submit', {'form': 'Klaviyo form', 'form_id': e.detail.formId});
      if(e.detail.formId == "VFD7H8"){
        fbq('track', 'CompleteRegistration', {
          form_name: 'Giveaway Form',
          source: 'https://theladcollective.us/pages/1-of-5-bedding-set-giveaway'
        });
      };
      if(e.detail.formId == "QNnx4J"){
        fbq('track', 'CompleteRegistration', {
          form_name: 'Black Friday Hype Form',
          source: 'https://theladcollective.us/collections/black-friday-hype'
        });
      };
    }
    if (e.detail.type == 'stepSubmit') {
      gtag('event', 'form_step_submit', {'form': 'Klaviyo form', 'step_name': e.detail.metaData.$step_name});
    }
    if (e.detail.type == 'redirectedToUrl') {
      gtag('event', 'form_url_redirect', {'form': 'Klaviyo form', 'form_id': e.detail.formId});
    }
    if (e.detail.type == 'close') {
      gtag('event', 'form_close', {'form': 'Klaviyo form', 'form_id': e.detail.formId});
    }
  });